// src/pages/HistoryPageChina.js
import React from 'react';
import TopicPage from '../../../components/TopicPageNew';
import bg from '../../../assets/history2/Ancient_Civilizations_-_Indus_Valley.png';

export default function HistoryPageIndusvalley() {
  return (
    <TopicPage
      topicKey="Indus Valley"
      title="History: Ancient Indus Valley"
      backgroundImage={bg}
      startRoute="/History-Ancient-Indusvalley-Go"
      scrollLabels={[
        "Religion and Culture",
        "Agriculture and Irrigation",
        "Trade and Economy",
      ]}
  backRoute="/history-Ancient-Civilizations"   // go back to the Middle-Ages menu
  backLabel="← Return to topics"
  backButtonClassName="journey-button special"
  backButtonStyle={{ fontSize: '1.1rem', backgroundColor: '#553c0d' }}
    />
  );
}
